// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { IPreviewStyle } from '../../../../../../CommonScripts/Abstractions';

function setUpContext(context: CanvasRenderingContext2D, style: IPreviewStyle) {
    if (!context.setLineDash) {
        context.setLineDash = function () { };
    }
    const width = context.canvas.width;
    const height = context.canvas.height;
    context.clearRect(0, 0, width, height);
    const lineDash = style.stroke.dash;

    //this.m_canvasContext.beginPath();
    context.lineWidth = style.stroke.w;
    context.strokeStyle = `rgba(${style.stroke.r},${style.stroke.g},${style.stroke.b},${style.stroke.a})`;
    context.fillStyle = `rgba(${style.fill.r},${style.fill.g},${style.fill.b},${style.fill.a})`;
    if (style.stroke.lineJoin) {
        switch (style.stroke.lineJoin.toLowerCase()) {
            case 'round':
                context.lineJoin = 'round';
                break;
            case 'bevel':
                context.lineJoin = 'bevel';
                break;
            case 'miter':
                context.lineJoin = 'miter';
                break;
        }
    }
    if (style.stroke.lineCap) {
        switch (style.stroke.lineCap.toLowerCase()) {
            case 'butt':
                context.lineCap = 'butt';
                break;
            case 'round':
                context.lineCap = 'round';
                break;
            case 'square':
                context.lineCap = 'square';
                break;
        }
    }
    if (lineDash)
        context.setLineDash(lineDash);
    else
        context.setLineDash([0]);
}
export function renderPolygon(context: CanvasRenderingContext2D, style: IPreviewStyle, backgroundImage: ImageData) {
    const width = context.canvas.width;
    const height = context.canvas.height;
    const lineWidth = style.stroke.w;
    setUpContext(context, style);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);

    const topLeftCornerX = 20;
    const topLeftCornerY = 20;
    const canvasWidth = width - (topLeftCornerX * 2);
    const canvasHeight = height - (topLeftCornerX * 2);

    // Draw the filled rectangle
    context.beginPath();
    context.moveTo(topLeftCornerX, topLeftCornerY);
    context.lineTo(topLeftCornerX + canvasWidth, topLeftCornerY);
    context.lineTo(topLeftCornerX + canvasWidth, topLeftCornerY + canvasHeight);
    context.lineTo(topLeftCornerX, topLeftCornerY + canvasHeight);
    context.closePath();
    context.fill();

    // Draw the containing rectangle, this is done separately to stop the bleed.
    context.beginPath();
    context.moveTo(topLeftCornerX - lineWidth / 2, topLeftCornerY - lineWidth / 2);
    context.lineTo(topLeftCornerX + canvasWidth + lineWidth / 2, topLeftCornerY - lineWidth / 2);
    context.lineTo(topLeftCornerX + canvasWidth + lineWidth / 2, topLeftCornerY + canvasHeight + lineWidth / 2);
    context.lineTo(topLeftCornerX - lineWidth / 2, topLeftCornerY + canvasHeight + lineWidth / 2);
    context.closePath();
    context.stroke();
};
export function renderLine(context: CanvasRenderingContext2D, style: IPreviewStyle, backgroundImage: ImageData) {

    const width = context.canvas.width;
    const height = context.canvas.height;
    const lineWidth = style.stroke.w;
    setUpContext(context, style);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);
    const topLeftCornerX = 20;
    const topLeftCornerY = 20;
    const canvasWidth = width - (topLeftCornerX * 2);
    const canvasHeight = height - (topLeftCornerX * 2);

    // Draw the filled line
    context.beginPath();
    context.moveTo(topLeftCornerX - lineWidth / 2, topLeftCornerY - lineWidth / 2);
    context.lineTo(topLeftCornerX + canvasWidth / 3 + lineWidth / 2, topLeftCornerY + canvasHeight + lineWidth / 2);
    context.lineTo(topLeftCornerX + (canvasWidth / 3) * 2 + lineWidth / 2, topLeftCornerY - lineWidth / 2);
    context.lineTo(topLeftCornerX + canvasWidth + lineWidth / 2, topLeftCornerY + canvasHeight + lineWidth / 2);
    context.stroke();
};
export function renderCircle(context: CanvasRenderingContext2D, style: IPreviewStyle, backgroundImage: ImageData) {

    const width = context.canvas.width;
    const height = context.canvas.height;
    setUpContext(context, style);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);
    const centreX = width / 2;
    const centreY = height / 2;
    const radius = (Math.min(width, height) - 20) / 2;


    // Draw the filled circle
    context.beginPath();
    context.arc(centreX, centreY, radius, 0, Math.PI * 2, true);
    context.fill();

    // Draw the containing rectangle, this is done separately to stop the bleed.
    context.beginPath();
    context.arc(centreX, centreY, radius, 0, Math.PI * 2, true);
    context.stroke();
};
export function renderText(context: CanvasRenderingContext2D, style: IPreviewStyle, backgroundImage: ImageData) {

    const centreX = context.canvas.width / 2;
    const centreY = context.canvas.height / 2;
    setUpContext(context, style);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = style.text.font;
    // Draw the text
    context.strokeText(style.text.text, centreX, centreY);
    context.fillText(style.text.text, centreX, centreY);
};
export function renderPoint(context: CanvasRenderingContext2D, style: IPreviewStyle, backgroundImage: ImageData) {

    const width = context.canvas.width;
    const height = context.canvas.height;
    setUpContext(context, style);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);
    const centreX = width / 2;
    const centreY = height / 2;
    const radius = style.point.radius;


    // Draw the filled circle
    context.beginPath();
    context.arc(centreX, centreY, radius, 0, Math.PI * 2, true);
    context.fill();

    // Draw the containing rectangle, this is done separately to stop the bleed.
    context.beginPath();
    context.arc(centreX, centreY, radius, 0, Math.PI * 2, true);
    context.stroke();
};
export function renderPointImage(context: CanvasRenderingContext2D, imageUrl: string, backgroundImage: ImageData) {

    const width = context.canvas.width;
    const height = context.canvas.height;
    context.clearRect(0, 0, width, height);
    if (backgroundImage)
        context.putImageData(backgroundImage, 0, 0);
    const centreX = width / 2;
    const centreY = height / 2;
    const img = new Image();
    img.onload = () => {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        //now draw our image into the display canvas
        context.drawImage(img, 0, 0, imgWidth, imgHeight, centreX - (imgWidth / 2), centreY - (imgHeight / 2), imgWidth, imgHeight );
    }

    img.src = imageUrl;

};


